export const tryParseInt = (value: string, defaultValue = null): number => {
  const parsedValue = parseInt(value, 10);

  if (isNaN(parsedValue)) {
    return defaultValue;
  }
  return parsedValue;
};

export const tryParseFloat = (value: string, defaultValue = null): number => {
  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue)) {
    return defaultValue;
  }
  return parsedValue;
};
